<template>
  <div class="container doubts-container adminWeeducEditCourse p-4" data-aos="fade-left" data-aos-duration="1500">
    <div class="titleContainer myCoursesWeeduc mb-3">
      <h3>{{ $t('admin.courseForm.titleEditPage') }}</h3>
      <p style="font-size: 14px;margin-bottom: 0;">
        {{ $t('admin.courseForm.subtitleEdit') }}
      </p>
    </div>

    <div class="">
      <div class="form-row new-course">
        <div class="form-group col-6">
          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.name') }}*</p>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                v-model="courseData.courseName"
                :placeholder="$t('admin.courseForm.namePlaceholder')"
                required
                @input="updateCourseUrl"
              />
            </div>
          </div>

          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.commercialNameLabel') }}*</p>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                v-model="courseData.commercialName"
                :placeholder="$t('admin.courseForm.commercialNamePlaceholderAlt')"
                required
              />
            </div>
          </div>

          <div class="form-row" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end;">
            <div class="form-group col-12 stuatus">
                <p class="form-label-title">{{ $t('admin.courseForm.status') }}*</p>
                <div class="form-input">
                  <select class="form-control" v-model="courseData.courseStatus" required>
                    <option value="1">{{ $t('common.active') }}</option>
                    <option value="2">{{ $t('admin.courseForm.statusInternalOnly') }}</option>
                    <option value="3">{{ $t('admin.courseForm.statusWaiting') }}</option>
                    <option value="4">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
              </div>
            <div class="form-group col-1 price" style="min-width: 140px;">
              <p class="form-label-title">{{ $t('admin.courseForm.price') }}</p>
              <div class="form-input">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">R$</span>
                  </div>
                  <input
                    type="text"
                    class="form-control price-input"
                    :value="courseData.coursePrice !== null ? courseData.coursePrice.toString().replace('.', ',') : ''"
                    :placeholder="$t('admin.courseForm.pricePlaceholder')"
                    required
                    pattern="[0-9,]*"
                    inputmode="decimal"
                    @input="formatPrice"
                  />
                </div>
              </div>
            </div>

            <div class="form-group col-1 discount" style="min-width: 140px;">
              <p class="form-label-title">{{ $t('admin.courseForm.discount') }}</p>
              <div class="form-input">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">R$</span>
                  </div>
                  <input
                    type="text"
                    class="form-control price-input"
                    :value="courseData.discountAmount !== null ? courseData.discountAmount.toString().replace('.', ',') : ''"
                    :placeholder="$t('admin.courseForm.pricePlaceholder')"
                    required
                    pattern="[0-9,]*"
                    inputmode="decimal"
                    @input="formatDiscount"
                  />
                </div>
              </div>
            </div>

            <div class="form-group col-1" style="min-width: 140px;">
              <p class="form-label-title">{{ $t('admin.courseForm.finalValue') }}*</p>
              <div class="form-input">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">R$</span>
                  </div>
                  <input
                    type="text"
                    class="form-control price-input"
                    :value="finalValue"
                    :placeholder="$t('admin.courseForm.pricePlaceholder')"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.url') }}*</p>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                v-model="courseData.courseUrl"
                :placeholder="$t('admin.courseForm.urlPlaceholder')"
                required
              />
            </div>
          </div>

          <div class="form-group col-12">
            <label class="form-label-title">{{ $t('admin.courseForm.shortDescription') }}</label>
            <div class="form-input">
              <textarea
                class="form-control"
                v-model="courseData.courseDescription"
                :placeholder="$t('admin.courseForm.shortDescriptionPlaceholder')"
                rows="4"
              ></textarea>
            </div>
          </div>

          <div class="form-group col-12">
            <label class="form-label-title">{{ $t('admin.courseForm.fullDescription') }}</label>
            <div class="form-input">
              <textarea
                class="form-control"
                v-model="courseData.courseLongDescription"
                :placeholder="$t('admin.courseForm.descriptionPlaceholder')"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="form-group col-6">
         
          <div class="form-group col-12" style="display: flex; align-items: flex-end; gap: 16px;">
            <div class="form-input" :style="(courseData.approvalEnabled === true || courseData.approvalEnabled === 'true') ? 'width: 50%;' : 'width: 100%;'">
              <p class="form-label-title">{{ $t('admin.courseForm.enableApproval') }}</p>
              <select class="form-control" v-model="courseData.approvalEnabled" :disabled="showImportedQuestions" required>
                <option :value="true">{{ $t('common.active') }}</option>
                <option :value="false">{{ $t('common.inactive') }}</option>
              </select>
            </div>
            <div v-if="courseData.approvalEnabled === true || courseData.approvalEnabled === 'true'" class="form-input" style="width: 50%;">
              <p class="form-label-title">{{ $t('admin.courseForm.minGrade') }}</p>
              <select class="form-control" v-model="courseData.minGrade" required>
                <option v-for="n in 11" :key="n-1" :value="n-1">{{ n-1 }}</option>
              </select>
            </div>
          </div>

          <div class="form-group col-12" style="display: flex; align-items: flex-end; gap: 16px;">
            <div class="form-input" :style="courseData.certificateEnabled === true || courseData.certificateEnabled === 'true' ? 'width: 50%;' : 'width: 100%;'">
              <p class="form-label-title">{{ $t('admin.courseForm.certificate') }}</p>
              <select class="form-control" v-model="courseData.certificateEnabled" required>
                <option :value="true">{{ $t('common.active') }}</option>
                <option :value="false">{{ $t('common.inactive') }}</option>
              </select>
            </div>
            <div v-if="courseData.certificateEnabled === true || courseData.certificateEnabled === 'true'" class="form-input" style="width: 50%;">
              <p class="form-label-title">{{ $t('admin.courseForm.certificateType') }}</p>
              <select class="form-control" v-model="courseData.certificateType" required>
                <option value="certificado1">{{ $t('admin.courseForm.certificateStandard') }}</option>
                <option value="certificado2">{{ $t('admin.courseForm.certificateAdvanced') }}</option>
                <option value="certificado3">{{ $t('admin.courseForm.certificateSpecial') }}</option>
              </select>
            </div>
          </div>

          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.availabilityDeadline') }}</p>
            <div class="form-input">
              <select class="form-control" v-model="courseData.availabilityDeadline" required>
                <option value="">{{ $t('admin.courseForm.lifelong') }}</option>
                <option value="12">1 Ano</option>
                <option value="6">6 Meses</option>
                <option value="3">3 Meses</option>
                <option value="1">{{ $t('admin.courseForm.oneMonth') }}</option>
              </select>
            </div>
          </div>

          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.coverMain') }}</p>
            <div class="form-file">
              <div class="file-wrapper primary">
                <span class="thumbnail thumb-img">
                  <img v-if="imagePreviewCover" :src="imagePreviewCover" class="preview-image" />
                  <span class="icon" v-if="loaderImage && !imagePreviewCover">
                    <svg width="46" height="39" viewBox="0 0 46 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501" stroke="#9D9FA3" stroke-width="1.25714"></path>
                      <rect x="1.00049" y="1.40454" width="43.9461" height="36.1909" rx="2.58507" stroke="#9D9FA3" stroke-width="1.25714"></rect>
                      <circle cx="14.8948" cy="10.6676" r="3.71629" stroke="#9D9FA3" stroke-width="1.25714"></circle>
                    </svg>
                  </span>
                  <span class="text" v-if="loaderImage && !imagePreviewCover">
                    {{ $t('admin.courseForm.selectImage') }}
                  </span>
                  <LoaderImage :hasReady="loaderImage"/>
                </span>
                <input class="form-control" type="file" @change="updateFileCover" accept=".png, .jpg, .jpeg, .webp"/>
              </div>
              <div class="form-caption">
                <div class="caption"></div>
              </div>
            </div>
          </div>

          <div class="form-group col-12">
            <p class="form-label-title">{{ $t('admin.courseForm.coverThumbnail') }}</p>
            <div class="form-file">
              <div class="file-wrapper primary">
                <span class="thumbnail thumb-img">
                  <img v-if="imagePreviewCover2" :src="imagePreviewCover2" class="preview-image" />
                  <span class="icon" v-if="loaderImage2 && !imagePreviewCover2">
                    <svg width="46" height="39" viewBox="0 0 46 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501" stroke="#9D9FA3" stroke-width="1.25714"></path>
                      <rect x="1.00049" y="1.40454" width="43.9461" height="36.1909" rx="2.58507" stroke="#9D9FA3" stroke-width="1.25714"></rect>
                      <circle cx="14.8948" cy="10.6676" r="3.71629" stroke="#9D9FA3" stroke-width="1.25714"></circle>
                    </svg>
                  </span>
                  <span class="text" v-if="loaderImage2 && !imagePreviewCover2">
                    {{ $t('admin.courseForm.selectImage') }}
                  </span>
                  <LoaderImage :hasReady="loaderImage2"/>
                </span>
                <input class="form-control" type="file" @change="updateFileCover2" accept=".png, .jpg, .jpeg, .webp"/>
              </div>
              <div class="form-caption">
                <div class="caption"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="button-container">
        <button class="btn-weflix default" @click="$router.go(-1)">{{ $t('common.cancel') }}</button>
        <button class="btn-weflix primary default" @click="updateCourse">Salvar</button>
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderImage from '@/components/Weflix/LoaderImage'
import Loader from '@/components/Weflix/Loader'
import apiAWS from '@/utils/storage/aws'
import apiCourses from '@/utils/courses'
import { toast } from 'vue3-toastify';

export default {
  data() {
    return {
      loading: false,
      courseData: {
        courseName: '',
        coursePrice: null,
        courseStatus: '1',
        courseDescription: '',
        courseLongDescription: '',
        coverImage: null,
        thumbnailImage: null,
        availabilityDeadline: '',
        commercialName: '',
        courseUrl: '',
        approvalEnabled: false,
        approvalCriteria: '',
        discountAmount: 0,
        certificateEnabled: false,
        certificateType: 'certificado1',
        minGrade: 0
      },
      loaderImage: true,
      loaderImage2: true,
      imagePreviewCover: null,
      imagePreviewCover2: null,
      coverVideo: null,
      coverVideo2: null,
      courseId: null,
      hasReady: false,
      showImportedQuestions: false,
      oldCourseName: ''
    }
  },
  computed: {
    ...mapState(['token']),
    finalValue() {
      let price = parseFloat(this.courseData.coursePrice) || 0
      let discount = parseFloat(this.courseData.discountAmount) || 0
      let value = price - discount
      if (value < 0) value = 0
      return value.toFixed(2).replace('.', ',')
    }
  },
  methods: {
    ...mapActions(['storeCurrentCollections']),
    async getCourseData() {
      try {
        this.loading = true
        const response = await apiCourses.getCourse(this.courseId, this.token)
        this.courseData = {
          courseName: response.name || '',
          coursePrice: response.price,
          courseStatus: response.status ? response.status.toString() : '1',
          courseDescription: response.shortDescription || '',
          courseLongDescription: response.longDescription || '',
          coverImage: response.imagePath || null,
          thumbnailImage: response.imagePath2 || null,
          availabilityDeadline: response.dayExpired || '',
          commercialName: response.comercialName || '',
          courseUrl: response.url || '',
          approvalEnabled: response.approved === 1,
          approvalCriteria: response.approvalCriteria || '',
          discountAmount: response.discount || 0,
          certificateEnabled: response.certificate === 1,
          certificateType: response.certificateType || 'certificado1',
          minGrade: response.minGrade !== undefined ? response.minGrade : 0
        }
        this.imagePreviewCover = response.imageFinalPath || null
        this.imagePreviewCover2 = response.imageFinalPath2 || null
        this.coverVideo = response.imagePath || null
        this.coverVideo2 = response.imagePath2 || null
        this.hasReady = true
      } catch (error) {
        console.error('Erro ao carregar dados do curso:', error)
      } finally {
        this.loading = false
      }
    },
    formatPrice(event) {
      let value = event.target.value.replace(/\D/g, '')
      value = (Number(value) / 100).toFixed(2)
      this.courseData.coursePrice = value
    },
    formatDiscount(event) {
      let value = event.target.value.replace(/\D/g, '')
      value = (Number(value) / 100).toFixed(2)
      this.courseData.discountAmount = value
    },
    updateCourseUrl() {
      const formattedUrl = (this.courseData.courseName || '')
        .toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, '')
        .replace(/ç/g, 'c')
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '-')
        .trim()
      this.courseData.courseUrl = formattedUrl
    },
    async updateCourse() {
      const payload = {
        id: this.courseId,
        name: this.courseData.courseName,
        price: this.courseData.coursePrice,
        status: this.courseData.courseStatus,
        coverImage: this.coverVideo,
        thumbnailImage: this.coverVideo2,
        certificate: this.courseData.certificateEnabled ? 1 : 0,
        comercialName: this.courseData.commercialName,
        url: this.courseData.courseUrl,
        shortDescription: this.courseData.courseDescription,
        longDescription: this.courseData.courseLongDescription,
        imagePath: this.coverVideo,
        imagePath2: this.coverVideo2,
        dayExpired: this.courseData.availabilityDeadline,
        approved: this.courseData.approvalEnabled ? 1 : 0,
        installment: 0,
        order: 0,
        discount: this.courseData.discountAmount,
        certificateType: this.courseData.certificateType,
        minGrade: this.courseData.minGrade,
        approvalCriteria: this.courseData.approvalCriteria
      }
      try {
        this.hasReady = false
        await apiCourses.editCourse(this.courseId, payload, this.token)
        this.getCourseData()
        this.notify('Curso editado com sucesso!', 'success')
      } catch (error) {
        this.notify('Erro ao atualizar curso', 'error')
        console.error('Erro ao atualizar curso:', error)
      }
    },
    async putFileAws(url, file) {
      try {
        const response = await apiAWS.putFileAWS(url, file)
        return response
      } catch (error) {
        console.error('Erro ao enviar arquivo para AWS')
      }
    },
    async updateFileCover(event) {
      this.loaderImage = false
      const file = event.target.files[0]
      if (!file) {
        this.loaderImage = true
        return
      }
      this.imagePreviewCover = URL.createObjectURL(file)
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name)
        await this.putFileAws(response.url, file)
        this.coverVideo = response.token
        this.loaderImage = true
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS')
        this.loaderImage = true
      }
    },
    async updateFileCover2(event) {
      this.loaderImage2 = false
      const file = event.target.files[0]
      if (!file) {
        this.loaderImage2 = true
        return
      }
      this.imagePreviewCover2 = URL.createObjectURL(file)
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name)
        await this.putFileAws(response.url, file)
        this.coverVideo2 = response.token
        this.loaderImage2 = true
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS')
        this.loaderImage2 = true
      }
    },
    notify(message, type = "info") {
      toast(message, {
        autoClose: 3000,
        position: 'top-right',
        theme: "light", 
        limit: 1,
        type: type,
        dangerouslyHTMLString: true
      });
    },
  },
  watch: {
    'courseData.courseName'(newVal) {
      const commercial = this.courseData.commercialName;
      if (!commercial || commercial === this.oldCourseName) {
      this.courseData.commercialName = newVal;
      }
      this.oldCourseName = newVal;
    }
  },
  created() {
    this.courseId = this.$route.params.slug
    this.getCourseData()
  },
  components: {
    LoaderImage,
    Loader
  }
}
</script>

<style scoped>
@import '@/css/weeduc/admin/createCourse.css';
</style>